module.exports = __webpack_public_path__ + "img/porsche-logo.fd2603b4.webp";